export const mediaSortings = [
  {
    attribute: 'updatedAt',
    accessor: p => p.startDate || p.updatedAt || p.createdAt,
    label: 'Nach Aktualität sortieren',
  },
  {
    attribute: 'title',
    label: 'Alphabetisch sortieren',
  },
];

export const mediaSortingDefault = {
  attribute: 'updatedAt',
  direction: 'down',
};

export const eventSortings = [
  {
    attribute: 'startDate',
    accessor: p => p.startDate || '',
    label: 'Nach Datum sortieren',
  },
];

export const eventSortingDefault = {
  attribute: 'startDate',
  direction: 'down',
};

export const dateSortingDefault = {
  attribute: 'startDate',
  direction: 'up',
};

export const CONTEXT_PAGE_LABELS = {
  hackschnitzel: 'ENplus Hackschnitzel',
  pellets: 'ENplus Pellets',
  holzbriketts: 'ENplus Briketts',
  depi: 'DEPI',
  depv: 'DEPV',
};
